var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarChartPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    zoomAndPan: "magnify",
    viewBox: "0 0 300 299.999988",
    height: 400,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "e4fcd30e14"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "38120ac173"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#e4fcd30e14)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    width: 360,
    fill: "#000000",
    y: -29.999999,
    height: 359.999986,
    fillOpacity: 0.75
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "f23e65cd0a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 7 L 238.800781 7 L 238.800781 137 L 0 137 Z M 0 7 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c493294dbc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 239,
    y: 0,
    height: 221
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#38120ac173)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 30, 37)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c493294dbc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M 26.765625 219.703125 L 60.277344 219.703125 L 60.277344 109.453125 L 26.765625 135.488281 Z M 26.765625 219.703125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M 87.027344 88.664062 L 75.832031 97.363281 L 75.832031 219.707031 L 109.34375 219.707031 L 109.34375 117.414062 C 108.601562 116.742188 107.90625 116.011719 107.289062 115.203125 Z M 87.027344 88.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M 124.894531 121.183594 L 124.894531 219.707031 L 158.40625 219.707031 L 158.40625 95.65625 L 131.246094 117.980469 C 129.378906 119.523438 127.195312 120.566406 124.894531 121.183594 Z M 124.894531 121.183594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M 173.957031 219.703125 L 207.46875 219.703125 L 207.46875 55.332031 L 173.957031 82.871094 Z M 173.957031 219.703125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f23e65cd0a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M 232.152344 7.246094 L 226.914062 8.042969 C 221.710938 8.828125 213.191406 10.117188 207.976562 10.902344 L 202.75 11.699219 C 197.546875 12.484375 195.964844 16.5 199.25 20.609375 L 202.554688 24.742188 C 203.082031 25.402344 203.691406 26.167969 204.308594 26.941406 L 121.796875 94.777344 L 95.792969 60.710938 C 94.628906 59.191406 92.910156 58.199219 91.011719 57.953125 C 89.101562 57.707031 87.199219 58.234375 85.675781 59.398438 L 0 125.5625 L 8.808594 136.914062 L 88.773438 75.191406 L 114.898438 109.402344 C 116.078125 110.949219 117.839844 111.953125 119.773438 112.171875 C 121.714844 112.40625 123.648438 111.828125 125.15625 110.589844 L 213.265625 38.167969 C 213.707031 38.710938 214.128906 39.238281 214.503906 39.714844 L 217.804688 43.847656 C 221.078125 47.957031 225.34375 47.324219 227.265625 42.410156 L 229.195312 37.492188 C 231.121094 32.582031 234.265625 24.554688 236.1875 19.660156 L 238.121094 14.726562 C 240.042969 9.835938 237.355469 6.460938 232.152344 7.246094 Z M 232.152344 7.246094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartPlaceholder);
export default __webpack_public_path__ + "static/media/bar-chart-placeholder.4567e54da0ab6e626199de31116d5c1d.svg";
export { ForwardRef as ReactComponent };